<div class="wm-view wm-l-issuereporter-container webmate-default-theme">
  <div class="wm-topbar">
    <span class="header">Request Device Update</span>
  </div>
  <div class="introduction-text">
    <div>
      You are requesting an OS update for {{data.modelName}}, currently running OS version {{data.currentVersion}}.
      Following your request, the device will be updated in the coming days.
    </div>
  </div>
  <form class="form">
    <div class="form-section">
      <div class="form-section-info">
        <h4 class="form-label">Additional Information</h4>
        <div class="description">You can provide some additional information for our support staff. It's okay to leave this field blank.</div>
      </div>
      <div class="form-item-content">
          <textarea data-testing-id="issue-details-textarea" class="form-item-input" type="text" placeholder="Additional Details (Optional)" [(ngModel)]="message" name="message" pTextarea [cols]="50" [rows]="8">
          </textarea>
      </div>
    </div>
    <button class= "submit-button" [disabled]="busySendingReport" (click)="requestUpdate()" [label]="busySendingReport ? 'Sending Request...' : 'Send Request'" pButton type="button"></button>
  </form>

</div>
